export default {
  settings: {
    header: {
      generalSettings: 'General Settings',
      plans: 'Plans',
      hubs: 'Hubs',
      wallet: 'Wallet',
      googleCalendar: 'Google Calendar',
      storage: 'Storage',
      archive: 'Archive',
      logOut: 'Log Out',
    },
  },
};
